module.exports = __webpack_public_path__ + "static/3-a3582ffb7bac3916a39f2e464297693d.jpg";